import React from "react";
import { Link } from "react-router-dom";
import "../../styles/Support.css";

const Support = () => {
  return (
    <div className="support">
      <h3 className="support-title">Support Groups</h3>
      <div className="support-grid">
        <div className="support-card">
          <h4>Duchenne Muscular Dystrophy (DMD)</h4>
          <p>
            News and research on DMD and Becker:{" "}
            <Link
              to="https://www.ParentProjectMD.org"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              {" "}
              www.ParentProjectMD.org
            </Link>
          </p>
          <p>
            Information on 40 forms of neuromuscular disease:{" "}
            <Link
              to="https://www.MDA.org"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              www.MDA.org
            </Link>{" "}
          </p>
        </div>
        <div className="support-card">
          <h4>Spinal Muscular Atrophy (SMA)</h4>
          <p>
            Resources for individuals and families of individuals with SMA:{" "}
            <Link
              to="https://www.curesma.org"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              {" "}
              www.fsma.org
            </Link>
          </p>
          <p>
            Many links, news, and information:{" "}
            <Link
              to="https://www.SMAsupport.com"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              www.SMAsupport.com
            </Link>{" "}
          </p>
        </div>
        <div className="support-card">
          <h4>Post Polio Syndrome (PPS)</h4>
          <p>
            News, directory, links, more:{" "}
            <Link
              to="https://www.Post-Polio.org"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              {" "}
              www.Post-Polio.org
            </Link>
          </p>
        </div>
        <div className="support-card">
          <h4>Amyotrophic Lateral Sclerosis (ALS)</h4>
          <p>
            The Amyotrophic Lateral Sclerosis Association:{" "}
            <Link
              to="https://www.als.org"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              {" "}
              www.als.org
            </Link>
          </p>
          <p>
            News, research, guides, links:{" "}
            <Link
              to="https://www.RideForLife.com"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              www.RideForLife.com
            </Link>{" "}
          </p>
        </div>
        <div className="support-card">
          <h4>Equipment</h4>
          <p>
            Millennium Respiratory:{" "}
            <Link
              to="https://millenniumrespiratory.com"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              {" "}
              millenniumrespiratory.com
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Support;
